import api from '@api';
import { call, put, takeEvery } from 'redux-saga/effects';
import {
    getOrderMessagesOnExpeditionBoxDetailFetchSuccess,
    getOrderMessagesOnExpeditionBoxDetailFetchFailure,
    createOrderMessagesOnExpeditionBoxDetailFetchSuccess,
    createOrderMessagesOnExpeditionBoxDetailFetchFailure,
    updateOrderMessagesOnExpeditionBoxDetailFetchSuccess,
    updateOrderMessagesOnExpeditionBoxDetailFetchFailure,
    deleteOrderMessagesOnExpeditionBoxDetailFetchSuccess,
    deleteOrderMessagesOnExpeditionBoxDetailFetchFailure,
} from './reducer';
import { OrderMessagesOnExpeditionBoxDetailResType } from 'src/types/orderMessagesOnExpeditionBoxDetail';
import { OrderMessagesOnExpeditionBoxType } from 'src/types/orderMessagesOnExpeditionBox';
import translate from '@translate';

const getOrderMessagesOnExpeditionBoxDetailFetchRequest = async (idOrderMessagesOnExpeditionBox: string) => {
    const res = await api('get', `api/secure/messages-on-expedition-box/${idOrderMessagesOnExpeditionBox}`);
    return res.data;
};

function* getOrderMessagesOnExpeditionBoxDetailFetch(action: { type: string; payload: string }) {
    try {
        const response: OrderMessagesOnExpeditionBoxDetailResType = yield call((): any =>
            getOrderMessagesOnExpeditionBoxDetailFetchRequest(action.payload)
        );
        yield put(getOrderMessagesOnExpeditionBoxDetailFetchSuccess(response));
    } catch (error) {
        yield put(getOrderMessagesOnExpeditionBoxDetailFetchFailure({ error }));
    }
}

export function* getOrderMessagesOnExpeditionBoxDetailFetchWatch() {
    yield takeEvery(
        'orderMessagesOnExpeditionBoxDetail/getOrderMessagesOnExpeditionBoxDetailFetch',
        getOrderMessagesOnExpeditionBoxDetailFetch
    );
}

const createOrderMessagesOnExpeditionBoxDetailFetchRequest = async (data: OrderMessagesOnExpeditionBoxType) => {
    const res = await api('post', `api/secure/messages-on-expedition-box`, data);
    return res.data;
};

function* createOrderMessagesOnExpeditionBoxDetailFetch(action: {
    type: string;
    payload: OrderMessagesOnExpeditionBoxType;
}) {
    try {
        const response: OrderMessagesOnExpeditionBoxDetailResType = yield call((): any =>
            createOrderMessagesOnExpeditionBoxDetailFetchRequest(action.payload)
        );
        yield put(
            createOrderMessagesOnExpeditionBoxDetailFetchSuccess({
                ...response,
                messageSuccess: {
                    title: translate('orderMessagesOnExpeditionBox.message.created'),
                },
            })
        );
    } catch (error) {
        yield put(createOrderMessagesOnExpeditionBoxDetailFetchFailure({ error }));
    }
}

export function* createOrderMessagesOnExpeditionBoxDetailFetchWatch() {
    yield takeEvery(
        'orderMessagesOnExpeditionBoxDetail/createOrderMessagesOnExpeditionBoxDetailFetch',
        createOrderMessagesOnExpeditionBoxDetailFetch
    );
}

const updateOrderMessagesOnExpeditionBoxDetailFetchRequest = async (params: {
    idOrderMessagesOnExpeditionBox: string;
    data: OrderMessagesOnExpeditionBoxType;
}) => {
    const res = await api(
        'put',
        `api/secure/messages-on-expedition-box/${params.idOrderMessagesOnExpeditionBox}`,
        params.data
    );
    return res.data;
};

function* updateOrderMessagesOnExpeditionBoxDetailFetch(action: {
    type: string;
    payload: { idOrderMessagesOnExpeditionBox: string; data: OrderMessagesOnExpeditionBoxType };
}) {
    try {
        const response: OrderMessagesOnExpeditionBoxDetailResType = yield call((): any =>
            updateOrderMessagesOnExpeditionBoxDetailFetchRequest(action.payload)
        );
        yield put(
            updateOrderMessagesOnExpeditionBoxDetailFetchSuccess({
                ...response,
                messageSuccess: {
                    title: translate('orderMessagesOnExpeditionBox.message.updated'),
                },
            })
        );
    } catch (error) {
        yield put(updateOrderMessagesOnExpeditionBoxDetailFetchFailure({ error }));
    }
}

export function* updateOrderMessagesOnExpeditionBoxDetailFetchWatch() {
    yield takeEvery(
        'orderMessagesOnExpeditionBoxDetail/updateOrderMessagesOnExpeditionBoxDetailFetch',
        updateOrderMessagesOnExpeditionBoxDetailFetch
    );
}

const deleteOrderMessagesOnExpeditionBoxDetailFetchRequest = async (idOrderMessagesOnExpeditionBox: string) => {
    const res = await api('delete', `api/secure/messages-on-expedition-box/${idOrderMessagesOnExpeditionBox}`);
    return res.data;
};

function* deleteOrderMessagesOnExpeditionBoxDetailFetch(action: { type: string; payload: string }) {
    try {
        const response: OrderMessagesOnExpeditionBoxDetailResType = yield call((): any =>
            deleteOrderMessagesOnExpeditionBoxDetailFetchRequest(action.payload)
        );
        yield put(
            deleteOrderMessagesOnExpeditionBoxDetailFetchSuccess({
                ...response,
                messageSuccess: {
                    title: translate('orderMessagesOnExpeditionBox.message.deleted'),
                },
            })
        );
    } catch (error) {
        yield put(deleteOrderMessagesOnExpeditionBoxDetailFetchFailure({ error }));
    }
}

export function* deleteOrderMessagesOnExpeditionBoxDetailFetchWatch() {
    yield takeEvery(
        'orderMessagesOnExpeditionBoxDetail/deleteOrderMessagesOnExpeditionBoxDetailFetch',
        deleteOrderMessagesOnExpeditionBoxDetailFetch
    );
}
